<template>
  <APIForm />
</template>

<script>
import APIForm from '../../components/apis/APIForm';

export default {
  components: { APIForm },
};
</script>
